import React, { useState } from "react";
import axios from "axios";
import { useDropzone } from "react-dropzone";
import { Link } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import "./UploadResume.css";

const UploadResume = ({ onSuccess, jobId }) => {
  const [errors, setErrors] = useState({});
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [skills, setSkills] = useState([]);
  const [files, setFiles] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const validateForm = () => {
    let formErrors = {};

    if (!files || files.length === 0) {
      formErrors.files = "Resume file is required.";
    }

    if (!name) {
      formErrors.name = "Name is required.";
    }

    if (!phone) {
      formErrors.phone = "Phone number is required.";
    } else if (!/^\d+$/.test(phone)) {
      formErrors.phone = "Phone must contain only numbers.";
    }

    if (!email) {
      formErrors.email = "Email is required.";
    } else if (
      !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email)
    ) {
      formErrors.email = "Invalid email address.";
    }

    if (!skills) {
      formErrors.skills = "Skills are required.";
    }

    setErrors(formErrors);

    // Return true if no errors
    return Object.keys(formErrors).length === 0;
  };

  const resetForm = () => {
    setName("");
    setPhone("");
    setEmail("");
    setFiles([]);
    setErrors({});
    setSkills("");
  };

  const handleFormSubmit = async () => {
    if (!validateForm()) {
      return;
    }

    setIsSubmitting(true);

    const formData = new FormData();
    formData.append("name", name);
    formData.append("email", email);
    formData.append("mobile", phone);
    const skillsArray = skills.split(",").map((skill) => skill.trim());
    formData.append("skills[]", skillsArray);
    formData.append("resume", files[0]);
    if (jobId) {
      formData.append("apply_for", jobId);
    }

    try {
      const response = await axios.post(
        "https://hrms-api.apisod.ai/api/apply-on-job",
        formData,
        {}
      );
      resetForm();
      console.log("Response", response.data);
      const { message } = response.data;
      toast.success(message);
      if (onSuccess) onSuccess();
    } catch (error) {
      toast.error("Failed to submit resume.");
    } finally {
      setIsSubmitting(false);
    }
  };

  // Files logic

  const { getRootProps, getInputProps } = useDropzone({
    onDrop: (acceptedFiles) => {
      setFiles((prevFiles) => [
        ...prevFiles,
        ...acceptedFiles.map((file) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          })
        ),
      ]);
    },
    accept: {
      "application/pdf": [],
      "application/msword": [],
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
        [],
    },
  });

  const thumbs = files.map((file, index) => (
    <div className="file-list" key={file.name}>
      <img
        src={file.preview}
        onLoad={() => {
          URL.revokeObjectURL(file.preview);
        }}
        alt={file.name}
      />
      <span className="delete-img" onClick={() => handleDeleteFile(index)}>
        X
      </span>
    </div>
  ));
  const handleDeleteFile = (index) => {
    const updatedFiles = files.filter((_, i) => i !== index);
    setFiles(updatedFiles);
  };

  return (
    <div className="col-xl-12 col-sm-12 col-12 mb-4">
      <Toaster />
      <div className="card">
        <div className="form-creation">
          <div className="row">
            <div className="col-xl-6 col-sm-6 col-12 ">
              <div className="form-group">
                <label>
                  Name <span className="mandatory">*</span>{" "}
                </label>
                <input
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
                {errors.name && (
                  <span
                    className="error"
                    style={{ color: "red", fontSize: "12px" }}
                  >
                    {errors.name}
                  </span>
                )}
              </div>
            </div>
            <div className="col-xl-6 col-sm-6 col-12 ">
              <div className="form-group">
                <label>
                  Skills (comma-separated) <span className="mandatory">*</span>{" "}
                </label>
                <input
                  type="text"
                  value={skills}
                  onChange={(e) => setSkills(e.target.value)}
                />
                {errors.skills && (
                  <span
                    className="error"
                    style={{ color: "red", fontSize: "12px" }}
                  >
                    {errors.skills}
                  </span>
                )}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-6 col-sm-6 col-12 ">
              <div className="form-group">
                <label>
                  Phone <span className="mandatory">*</span>{" "}
                </label>
                <input
                  type="text"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                />
                {errors.phone && (
                  <span
                    className="error"
                    style={{ color: "red", fontSize: "12px" }}
                  >
                    {errors.phone}
                  </span>
                )}
              </div>
            </div>
            <div className="col-xl-6 col-sm-6 col-12 ">
              <div className="form-group">
                <label>
                  Email <span className="mandatory">*</span>{" "}
                </label>
                <input
                  type="text"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                {errors.email && (
                  <span
                    className="error"
                    style={{ color: "red", fontSize: "12px" }}
                  >
                    {errors.email}
                  </span>
                )}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-12 col-sm-12 col-12 ">
              <div className="form-group">
                <label>
                  Upload <span className="mandatory">*</span>{" "}
                </label>
                <div {...getRootProps()} className="dropzone">
                  <input {...getInputProps()} />
                  <p className="dropzone-content">
                    Drag 'n' drop leave related files here ( PDF, DOC)
                    <br />
                    or
                    <br />
                    click to select files (up to 500 KB)
                  </p>
                </div>
                <aside className="mai-file-list">{thumbs}</aside>
                {errors.files && (
                  <span className="error" style={{ color: "red" }}>
                    {errors.files}
                  </span>
                )}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-12 col-sm-12 col-12 ">
              <div className="form-btn">
                <button
                  type="button"
                  className="btn btn-apply"
                  onClick={handleFormSubmit}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Submitting..." : "Submit"}
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={resetForm}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UploadResume;
